import React, { useEffect, useRef } from 'react';
import ReviewCard from './ReviewCard';
import './ReviewsSection.css'; // Styles based on the new approach

const mockReviews = [
  { id: 1, author: "Daniel W.", text: "Mycket trevligt lunchställe med kanonbra pizzor och serviceminded personal! ❤️", rating: 5 },
  { id: 2, author: "Erik L.", text: "Mysig atmosfär och god pasta. Kommer tillbaka!", rating: 4 },
  { id: 3, author: "Maria B.", text: "Bästa italienska i stan! Rekommenderas varmt.", rating: 5 },
  { id: 4, author: "Johan P.", text: "Trevlig familjär atmosfär. Personalen är effektiv och serviceminded.Samt oliverna som var 👍 ", rating: 5 },
  { id: 5, author: "Linda K.", text: "Perfekt för en afterwork med vänner.", rating: 4 }
];

// Default speed can be controlled by CSS (--_animation-duration on .scroller__inner)
// Or by data-speed attribute on .scroller element.
// Default direction is left (forwards). data-direction="right" for reverse.

const ReviewsSection = () => {
  const scrollerRef = useRef(null);
  // Duplicating content for the animation loop.
  // The CSS animation expects the content to be effectively doubled.
  const duplicatedReviews = [...mockReviews, ...mockReviews];

  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;

    // Check for prefers-reduced-motion
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!prefersReducedMotion) {
      scroller.setAttribute("data-animated", "true");
      // The example JS also dynamically duplicates items here.
      // In React, we render the duplicatedReviews array directly.
      // If we needed to dynamically add aria-hidden to the second half,
      // we would map over mockReviews twice, adding aria-hidden to the second set.
      // For simplicity with the current CSS which expects a single continuous block,
      // we'll rely on the duplicated array.
    }
    // If prefersReducedMotion is true, data-animated is not set,
    // and CSS defaults to a non-animated, wrapping layout.
  }, []); // Empty dependency array ensures this runs once on mount

  return (
    <section className="mt-10 md:mt-16 p-6 rounded-xl">
      <div>
        <h2 className="text-2xl font-serif font-bold mb-6 text-center">
  
    Vad säger de om oss?

        </h2>
        {/*
          data-speed can be "fast" or "slow". Default is 40s.
          data-direction can be "left" (default) or "right".
          These are controlled by CSS custom properties.
        */}
        <div ref={scrollerRef} className="scroller" data-speed="fast"> {/* Example: data-speed="fast" */}
          <div className="scroller__inner">
            {/*
              The example JS dynamically clones children and adds aria-hidden.
              In React, we can map the duplicatedReviews.
              For proper accessibility with duplicated content for animation,
              the second half of the items should ideally have aria-hidden="true".
            */}
            {mockReviews.map((review, index) => (
              <div key={`original-${review.id}-${index}`} className="review-item-wrapper">
                <ReviewCard
                  author={review.author}
                  text={review.text}
                  rating={review.rating}
                />
              </div>
            ))}
            {mockReviews.map((review, index) => (
              <div key={`clone-${review.id}-${index}`} className="review-item-wrapper" aria-hidden="true">
                <ReviewCard
                  author={review.author}
                  text={review.text}
                  rating={review.rating}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;